import {CoreType} from './../../../../../../@polygonjs/polygonjs/src/core/Type';
import {Ref} from 'vue';
interface LocalStorageOptions {
	displayedShaderIndex: Ref<number>;
}

const KEY = 'shaderCodePreview-displayedShaderIndex';

export function SetupLocalStorage(options: LocalStorageOptions) {
	function saveToLocalStorage() {
		localStorage.setItem(KEY, `${options.displayedShaderIndex.value}`);
	}

	function loadFromLocalStorage() {
		return localStorage.getItem(KEY);
	}

	const current = loadFromLocalStorage();
	if (current) {
		const currentInt = parseInt(current);
		if (CoreType.isNumber(currentInt) && !CoreType.isNaN(currentInt)) {
			options.displayedShaderIndex.value = currentInt;
		}
	}

	return {
		saveToLocalStorage,
		loadFromLocalStorage,
	};
}
